import { render, staticRenderFns } from "./SentimentsAmdIndia.vue?vue&type=template&id=4b2d1b2f&scoped=true"
import script from "./SentimentsAmdIndia.vue?vue&type=script&lang=js"
export * from "./SentimentsAmdIndia.vue?vue&type=script&lang=js"
import style0 from "./SentimentsAmdIndia.vue?vue&type=style&index=0&id=4b2d1b2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2d1b2f",
  null
  
)

export default component.exports